import { Link, useLocation } from "react-router-dom";
import { ShieldCheck, HardDrive, Users } from "lucide-react";

/**
 * Sub-nav for the admin console. Shared across every /admin/* page so the
 * operator can flip between orphan-recovery and the users list without going
 * back to the home page.
 */
export default function AdminNav() {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/admin/orphans", label: "Orphans", icon: HardDrive, testId: "admin-nav-orphans" },
    { to: "/admin/users", label: "Users", icon: Users, testId: "admin-nav-users" },
  ];
  return (
    <div className="max-w-6xl mx-auto px-6 pt-8 pb-2 flex items-center gap-3">
      <ShieldCheck size={16} className="text-[#c89f45]" />
      <span className="label-eyebrow">Admin console</span>
      <div className="ml-4 flex items-center gap-1">
        {tabs.map((t) => {
          const active = pathname === t.to || pathname.startsWith(t.to + "/");
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={t.testId}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-mono uppercase tracking-widest transition-colors ${
                active
                  ? "text-[#c89f45] bg-[#c89f45]/10 border border-[#c89f45]/40"
                  : "text-[#888] border border-transparent hover:text-white hover:border-[#2a2a2a]"
              }`}
            >
              <Icon size={12} />
              {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
